import * as Sentry from '@sentry/browser'
import ravenConfig from '@/configs/raven-config'

const AppLoggerPlugin = {
  install (Vue) {
    const isProduction = Vue.appEnv.isProduction
    const isLocal = process.env.NODE_ENV !== 'production'
    const sentryEnvironment = isLocal ? 'local' : (isProduction ? 'production' : 'non-production')

    Sentry.init({
      dsn: ravenConfig.credentials,
      release: process.env.VUE_APP_VERSION,
      debug: Vue.appEnv.isDevelopment,
      environment: sentryEnvironment,
      tracesSampleRate: isProduction ? 0.2 : 1.0
    })

    Vue.logger = {
      log: (...ls) => {
        if (isProduction) return
        console.log(...ls)
      },
      logRemotely: (...ls) => {
        if (isProduction) return
        console.log(...ls)
        try {
          const data = ls.length === 1 ? ls[0] : ls
          Sentry.captureMessage(typeof data === 'string' ? data : JSON.stringify(data))
        } catch (e) { } // eslint-disable-line no-empty
      },
      error: e => {
        if (e instanceof Error) {
          Sentry.captureException(e)
        }
        if (!isProduction) {
          console.error(e)
        }
      }
    }
  }
}

export default AppLoggerPlugin
